// extracted by mini-css-extract-plugin
export default {"root":"styles_root__fZiso","error":"styles_error__H--Dh"};